<template></template>

<script>

/*
    props
    -----

    optionId - the id of the option
    versionId - the version id
    propertyName - the name of the property to be updated

    methods
    -------

    handleNewValue(newValue:String)

    events
    ------

    in-progress: a call has been made
    success: the call is complete. success
    error: the call is complete. with error
*/

import axios from 'axios';

let base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: 'options-general-api-handler',
    props: {
        optionId: Number,
        versionId: String,
        propertyName: String,
    },
    data() {
        return {};
    },
    methods: {
        handleNewValue(newValue) {
            this.saveNewValue(newValue, false);
        },
        handleNewValueWithSync(newValue) {
            this.saveNewValue(newValue, true);
        },
        saveNewValue(newValue, sync) {
            this.$emit('in-progress');
            axios.put(base_url + '/pimapi/options/' + this.optionId + '/version/' + this.versionId, {
                "property_name": this.propertyName,
                "new_value": newValue,
                "sync": sync
            })
            .then((response) => {
                this.$emit('success', response);
            })
            .catch((error) => {
                this.$emit('error', error);
            });
        }
    }
}
</script>
